'use strict';

function DataTables() {

    var exportButtons = {
        'dpl-datatable': [
            'copy',
            'excel',
            'print',
            {
                extend: 'colvis',
                columns: ':not(:first-child)'
            }
        ],
        'dpl-datatable-cv': [
            {
                extend: 'colvis',
                columns: ':not(:first-child)'
            }
        ]
    };

    var lengthOption1 = 75;
    var lengthOption2 = lengthOption1 * 2;
    var lengthOption3 = lengthOption1 * 3;
    var wrapper = '<div class="scrollStyle"/>';
    var lengthMenu = [[lengthOption1, lengthOption2, lengthOption3, -1], [lengthOption1, lengthOption2, lengthOption3, 'All']];
    var dom = '<lfB<t>ip>';
    var iDisplayLength = lengthOption1;
    var lengthChange = true;
    var dataSortOrder = null;
    var dataSortColumn = null;

    /********************************/
    // Init datatables
    /********************************/
    this.initDataTables = function () {

        if($.fn.dataTable.moment){
            $.fn.dataTable.moment('DD/MM/YYYY');
        }

        $('#catalogue').dataTable({
            'oLanguage': {
                'sSearch': 'Search: '
            },
            'dom': '<"row dt-pre"<"col-md-6"<"dt-title"><"pull-left"l>><"col-md-6 text-right"f>><"row dt-table"<"col-sm-12"tr>><"row dt-post"<"col-md-6"p><"col-md-6 text-right"il>>',
            'lengthChange': true,
        });

        $('#funding-catalogue').dataTable({
            'autoWidth': false,
            'oLanguage': {
                'sSearch': 'Search all columns'
            },
            'sDom': '<"row"<"col-md-6"p><"col-md-6"l>><"row"<"col-md-6"f><"col-md-6"i>>t<"row"<"col-md-12"p>>'
        });

        $('#budget-view-data-table').dataTable({
            'aoColumnDefs': [{}]
        });

        $('#mixedSelect').dataTable({
            dom: 'Bfrtip',
            'order': [[1, 'asc']]
        });

        $('#documents-table, #document-records, #pg-taught-documentation, #generated-correspondence, .dpl-datatable').dataTable({
            dom: '<"row"<"col-md-4"ilf><"col-md-8 text-right"B>><"row dt-table"<"col-sm-12"tr>><"row dt-post"<"col-md-12"p>>',
            /*dom: '<"row"<"col-md-4"lf><"col-md-8 text-right"B>><"row dt-table"<"col-sm-12"tr>><"row dt-post"<"col-md-6"p><"col-md-6 text-right"il>>',*/
            lengthChange: lengthChange,
            'lengthMenu': lengthMenu,
            'iDisplayLength': iDisplayLength,
            buttons: exportButtons['dpl-datatable']
        }).wrap(wrapper);

        $('.dpl-datatable.no-export').dataTable({
            dom: '<"row"<"col-md-4"ilf><"col-md-8 text-right">><"row dt-table"<"col-sm-12"tr>><"row dt-post"<"col-md-12"p>>',
            lengthChange: lengthChange,
            'lengthMenu': lengthMenu,
            'iDisplayLength': iDisplayLength,
        }).wrap(wrapper);

        $('#academic-misconduct-records tfoot td').each(function () {
            $(this).html('<input class="form-control" type="text" placeholder="Search ' + $(this).text() + '">');
        });

        if ($('#academic-misconduct-records tbody tr').first().find('td').length > 1) {

            var t = $('#academic-misconduct-records');

            dataSortColumn = t.attr('data-sort-column') !== '' ? t.attr('data-sort-column') : 0;
            dataSortOrder = t.attr('data-sort-order') !== '' ? '"' + t.attr('data-sort-order') + '"' : 'asc';

            //dataSortColumn = 1;
            //dataSortOrder = 'desc';

            console.log('Sort order column: ' + dataSortColumn + ', Sort order :' + dataSortOrder);

            var academicMisconductTable = t.dataTable({
                'order': [[dataSortColumn, dataSortOrder]],
                dom: dom,
                lengthChange: lengthChange,
                'lengthMenu': lengthMenu,
                'iDisplayLength': iDisplayLength,
                buttons: exportButtons['dpl-datatable-cv'],
                'fnRowCallback': function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {

                    var sorted = [];

                    for (var i = 0; i < aData.length; i++) {
                        if (typeof aData[i] === 'string') {
                            sorted.push(aData[i].toLowerCase());
                        }
                    }

                    if ($.inArray('pending', sorted) > -1) {
                        $(nRow).css('color', 'green');
                    }
                    if ($.inArray('dismissed', sorted) > -1) {
                        $(nRow).css('color', 'red');
                    }
                },
                //initComplete: this.searchColumnBySelect($(this))
            }).wrap(wrapper);

            this.searchColumnByInput(academicMisconductTable);
        }
    };

    /********************************/
    // Search column with select
    /********************************/
    this.searchColumnBySelect = function (table) {
        table.api().columns().every(function () {
            var column = this;
            var select = $('<select class="form-control"><option value=""></option></select>')
                .appendTo($(column.footer()).empty())
                .on('change', function () {
                    var val = $(this).val();
                    column.search(val ? '^' + val + '$' : '', true, false).draw();
                });
            column.data().unique().sort().each(function (d, j) {
                select.append('<option value="' + d + '">' + d + '</option>');
            });
        });
    };

    /********************************/
    // Search column with input
    /********************************/
    this.searchColumnByInput = function (table) {
        table.api().columns().every(function () {
            var that = this;

            $('input', this.footer()).on('keyup change', function () {
                if (that.search() !== this.value) {
                    that
                        .search(this.value)
                        .draw();
                }
            });
        });

        $('#academic-misconduct-records > tfoot > tr > td').eq(0).html('');
    };
}
